<script setup>
import { isGlobalLoading } from "@/store/autoLogoutLoading";
</script>

<template>
  <div v-if="isGlobalLoading" class="auto-logout-overlay">
    <div class="spinner-border text-light" role="status">
      <span class="visually-hidden">Logging out...</span>
    </div>
  </div>
</template>

<style scoped>
.auto-logout-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
</style>
